import { render, staticRenderFns } from "./transferSamplesDialog.vue?vue&type=template&id=1fc44df5"
import script from "./transferSamplesDialog.vue?vue&type=script&lang=js"
export * from "./transferSamplesDialog.vue?vue&type=script&lang=js"
import style0 from "./transferSamplesDialog.vue?vue&type=style&index=0&id=1fc44df5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports